import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { getLocalStorageItem, LocalStorageKey, setLocalStorageItem, } from '@/shared/services/localStorageService';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import { FaCog } from 'react-icons/fa';
import { getKpiMessage } from '@/modules/tasks/taskKpiMessages';
import { MyTasksWidgetKPIOptions } from '@/modules/tasks/taskboard/constants';
import messages from '../dashboardMessages';
import { MultipleTaskKpiTiles } from './tasks/MultipleTaskKpiTiles';
import AuthService from '@/shared/services/AuthService';
export const capacityPlanningOptions = [
    MyTasksWidgetKPIOptions.executionDateBeforeThisWeek,
    MyTasksWidgetKPIOptions.executionDateThisWeek,
    MyTasksWidgetKPIOptions.executionDateNextWeek,
    MyTasksWidgetKPIOptions.executionDateInTwoWeeks,
    MyTasksWidgetKPIOptions.executionDateInThreeWeeks,
];
const IsKpiVisibleByDefault = (kipOptions) => {
    if (kipOptions === MyTasksWidgetKPIOptions.pastDeadline ||
        kipOptions === MyTasksWidgetKPIOptions.deadlineOneWeek ||
        kipOptions === MyTasksWidgetKPIOptions.deadlineTwoWeeks ||
        kipOptions === MyTasksWidgetKPIOptions.deadlineThreeWeeks)
        return true;
    return false;
};
const MyTaskKpiDashboard = () => {
    const { formatMessage } = useIntl();
    const getInitialConfiguredKpis = () => {
        const kpiConfigurationsInStorage = getLocalStorageItem(LocalStorageKey.MyTasksWidgetConfiguredKpis, []);
        const hasCapacityPlanning = AuthService.hasFeature('CapacityPlanning');
        const kpiConfigurations = Object.values(MyTasksWidgetKPIOptions)
            .filter(x => hasCapacityPlanning || capacityPlanningOptions.indexOf(x) < 0)
            .map(x => {
            var _a, _b;
            return ({
                id: x,
                label: formatMessage(getKpiMessage(x)),
                selected: (_b = (_a = kpiConfigurationsInStorage.find(y => y.id === x)) === null || _a === void 0 ? void 0 : _a.selected) !== null && _b !== void 0 ? _b : IsKpiVisibleByDefault(x),
                individualClassName: x === MyTasksWidgetKPIOptions.nextUserIsMe ? 'margin15B' : '',
                zendeskArticle: x === MyTasksWidgetKPIOptions.nextUserIsMe ? '9580127747356' : '',
                title: x === MyTasksWidgetKPIOptions.pastDeadline
                    ? formatMessage(messages.KPIs)
                    : x === MyTasksWidgetKPIOptions.executionDateBeforeThisWeek
                        ? formatMessage(messages.ExecutionDates)
                        : null,
            });
        });
        return kpiConfigurations;
    };
    const [kpiConfigurations, setKpiConfigurations] = useState(getInitialConfiguredKpis());
    const { setShowModalInfo } = useModalContext();
    const openKpiConfiguration = async () => {
        setShowModalInfo({
            modalType: ModalType.CheckboxList,
            showSelectAll: false,
            title: formatMessage(messages.ConfigureKpis),
            checkboxListItems: kpiConfigurations,
            onSave: async (items) => {
                // remove label, not needed to store in storage
                const storageItems = items.map(x => ({ id: x.id, selected: x.selected }));
                setLocalStorageItem(LocalStorageKey.MyTasksWidgetConfiguredKpis, storageItems);
                setKpiConfigurations(items);
            },
        });
    };
    return (_jsxs("div", Object.assign({ className: "my-task-kpi-dashboard" }, { children: [_jsxs("div", Object.assign({ className: "title-block" }, { children: [formatMessage(messages.MyTasks), _jsx("span", Object.assign({ className: "pull-right " }, { children: _jsx("span", { children: _jsx(FaCog, { className: "react-icon", style: { marginTop: '2px' }, onClick: openKpiConfiguration }) }) }))] })), _jsx("div", Object.assign({ className: "content-block" }, { children: _jsx(MultipleTaskKpiTiles, { configuredKpis: kpiConfigurations.filter(x => x.selected).map(x => x.id) }) }))] })));
};
export default MyTaskKpiDashboard;
